import { ExampleItemType } from "components/todolist/Reminders/typing";
import { FC } from "react";

interface ExampleItemProps {
  item: ExampleItemType;
  disabled?: boolean;
  onClick?: () => void;
}

const ExampleItem: FC<ExampleItemProps> = ({ item, disabled = false, onClick }) => {
  return (
    <div
      style={{
        padding: "8px",
        border: "1px solid #E9E9E9",
        backgroundColor: disabled ? "#F5F5F5" : "#FFFFFF",
        borderRadius: "8px",
        userSelect: "none",
        cursor: disabled ? "not-allowed" : "pointer",
      }}
      onClick={disabled ? undefined : onClick}
    >
      <div style={{ fontWeight: "bold" }}>{item.title}</div>
      <div style={{ color: "#94888A" }}>{item.description}</div>
    </div>
  );
};

export default ExampleItem;
